function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#828898",
  d: "M11.348 23.363c6.21 0 11.355-5.144 11.355-11.367 0-6.21-5.156-11.355-11.367-11.355C5.125.64-.02 5.785-.02 11.996c0 6.223 5.157 11.367 11.368 11.367zm0-2.027c-5.18 0-9.328-4.148-9.328-9.34 0-5.18 4.136-9.34 9.316-9.34 5.18 0 9.34 4.16 9.352 9.34.011 5.191-4.16 9.34-9.34 9.34zm-1.395-3.773c.375 0 .692-.188.926-.54l5.45-8.554c.151-.223.28-.48.28-.727 0-.527-.468-.867-.96-.867-.305 0-.586.176-.797.527l-4.946 7.91-2.554-3.269c-.247-.328-.516-.457-.832-.457-.504 0-.903.41-.903.926 0 .246.094.492.27.715l3.082 3.796c.304.375.597.54.984.54z"
});

function SvgApplied(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplied);
export default __webpack_public_path__ + "static/media/applied.60350067.svg";
export { ForwardRef as ReactComponent };